"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubModeEntreeRelationCorporationTrads = void 0;
exports.ESubModeEntreeRelationCorporationTrads = {
    rdv_distance: "Rendez-vous à distance",
    rdv_physique: "Rendez-vous physique",
};
